import { gql } from 'core/dna/types/apollo';

export const CREATE_LESSON_GROUP_MUTATION = gql`
  mutation createLessonGroup($input: CreateLessonGroupInput!) {
    createLessonGroup(input: $input) {
      id
    }
  }
`;
